import { ReactElement } from "react";

import { Button } from "../catalyst/Button";

type Props = {
  onChange(value: string): void;
  optionList: string[];
  value: string;
};

const RadioButtonGroup = ({
  onChange,
  optionList,
  value,
}: Props): ReactElement => {
  const options = optionList.map((dsType, i, list) => {
    const color =
      value == dsType ? "selected_radio_button" : "unselected_radio_button";
    const rounding =
      i == 0
        ? "rounded-l"
        : i == list.length - 1
          ? "-ml-px rounded-r"
          : "-ml-px rounded-none";
    const className = `flex-1 bg-green-500 text-white py-2 px-4 ${color} ${rounding}`;
    return (
      <Button
        className={className}
        key={i}
        onClick={() => {
          onChange(dsType);
        }}
      >
        {dsType}
      </Button>
    );
  });
  return <div className="flex pt-3">{options}</div>;
};

export default RadioButtonGroup;
